<div class="datepicker-wrapper">
  <div
    class="datepicker-container"
    [ngClass]="{ 'error-state': !getControl().untouched && getControl().invalid }"
  >
    <div class="datepicker-input-wrapper">
      <input
        [id]="'datepicker-' + getUniqueId()"
        type="date"
        lang="de"
        class="datepicker-input"
        [placeholder]="label() || ' '"
        [value]="formatDateForInput(getControl().value)"
        (change)="onDateChange($event)"
        (blur)="onDateBlur()"
        [disabled]="getControl().disabled"
        [attr.aria-invalid]="!getControl().valid && getControl().touched"
      />
      <span class="datepicker-icon">
        <htx-icon [icon]="'calendar_today'"></htx-icon>
      </span>
      @if (label()) {
        <label class="datepicker-label" [for]="'datepicker-' + getUniqueId()">
          {{ label() }}
          @if (required()) {
            <span class="required">*</span>
          }
        </label>
      }
    </div>
  </div>
</div>
